import API from "../Services/API";

const queues = {};
const timeouts = {};

const makeBatcher = (
    batchName,
    makeFetchUrl,
    itemKey,
    errorMessage = 'There was an error loading the items.',
    batchSize = 20,
    fetchTimeout = 50,
) => {
    queues[batchName] = queues[batchName] || [];
    timeouts[batchName] = timeouts[batchName] || null;

    const fetchInBatch = async (itemId, showError) => {

        return new Promise((resolve, reject) => {
            queues[batchName].push({ itemId, resolve, reject });
            if (timeouts[batchName]) {
                clearTimeout(timeouts[batchName]);
            }
            timeouts[batchName] = setTimeout(() => doFetchBatch(showError), fetchTimeout);
        });
    }

    const doFetchBatch = (showError) => {
        const queue = queues[batchName].splice(0, batchSize);
        const itemIds = queue.map(item => item.itemId);

        API.get(makeFetchUrl(itemIds)).then(data => {
            const keyedById = data.reduce((acc, item) => {
                acc[item[itemKey]] = item;
                return acc;
            }, {});
            queue.forEach(item => {
                item.resolve(keyedById[item.itemId] ?? null);
            });
        }).catch(err => showError(API.parseErrorResponse(err, errorMessage)));

        if (queues[batchName].length > 0) {
            timeouts[batchName] = doFetchBatch(showError);
        }
    }

    return fetchInBatch;
}

export default makeBatcher;
